import React from 'react';

const ZoomOutSVG = ({ title, ...props }) => (
  <svg aria-label={title} viewBox="0 0 24 24" {...props}>
    {title ? <title id="title">{title}</title> : null}
    <path d="M5 11L19 11L19 13L5 13L5 11z"/>
  </svg>
);

export default ZoomOutSVG;
